export default {
  header: {
    // 顶部
    projectTitle: "多能互补MW级模块化分布式能源系统项目",
    expand: "展开",
    shrink: "收缩",
    searchMenu: "搜索菜单",
    fullScreen: "全屏",
    exitFullScreen: "退出全屏",
    darkTheme: "暗黑主题",
    defaulTtheme: "默认主题",
    personalInfor: "个人信息",
    changeLangSuccess: "语言切换成功",
  },
};
